'use client';

import type { ReactNode } from 'react';
import { HStack } from '@terra/ui-styled-system';

export function ListPageCellFrame({
  children,
  justify = 'flex-start',
}: {
  children: ReactNode;
  justify?: 'flex-start' | 'center';
}) {
  return (
    <HStack
      w="full"
      h="full"
      minW={0}
      alignItems="center"
      justifyContent={justify}
    >
      {children}
    </HStack>
  );
}
